<template>
  <div class="message--inner">
    <modal
      class="modal--message-user"
      title="Message to user"
      v-if="showModal"
      :activate="showModal"
      @activate="showModal = $event"
    >
      <template slot="body">
        <div class="message-con">
          <div class="message__mailto">
            <div class="mailto-list">
              <div class="mailto-item">
                <span class="" >To All</span>
                <checkbox>
                  <input type="checkbox" @click="sendToAll = !sendToAll"/>
                </checkbox>
              </div>
              <div class="mailto-item">
                <span class="" >To Level</span>
                <select-list
                  ref="level"
                  title="Select Level"
                  v-model="selectedLevel"
                  :withReset="true"
                  v-if="levels.length > 0 && !sendToAll"
                >
                  <select-option
                    ref="option"
                    :value="level.id"
                    :name="level.name"
                    v-for="(level, i) in levels"
                    :key="i"
                  >
                    {{level.name}}
                  </select-option>
                </select-list>
                <span v-else>No data</span>
              </div>
              <div class="mailto-item">
                <span class="" >To Agent</span>
                <select-list
                  ref="agent"
                  title="Select Agent"
                  v-model="selectedAgent"
                  :withReset="true"
                  v-if="agents.length > 0 && !sendToAll"
                >
                  <select-option
                    :value="agent.id"
                    :name="agent.login_name"
                    v-for="(agent, i) in agents"
                    :key="i"
                  >
                    {{ agent.login_name }}
                  </select-option>
                </select-list>
                <span v-else>No data</span>
              </div>
              <div class="mailto-item">
                <span class="" >To Code</span>
                <select-list
                  ref="code"
                  title="Select Code"
                  :withReset="true"
                  v-model="selectedCode"
                  v-if="codes.length > 0 && !sendToAll"
                >
                  <select-option
                    :value="code.id"
                    :name="code.code"
                    v-for="(code, i) in codes"
                    :key="i"
                  >
                    {{ code.code }}
                  </select-option>
                </select-list>
                <span v-else>No data</span>
              </div>
              <div class="mailto-item">
                <span class="" >To Group</span>
                <!-- <div>{{ depositAccounts }}</div> -->
                <select-list
                  ref="account"
                  title="Select Group"
                  :withReset="true"
                  v-model="selectedAccount"
                  v-if="accounts.length > 0 && !sendToAll"
                >
                  <select-option
                    :value="account.id"
                    :name="account.name"
                    v-for="(account, i) in accounts"
                    :key="i"
                  >
                    {{ account.name }}
                  </select-option>
                </select-list>
                <span v-else>No data</span>
              </div>
              <div class="mailto-item">
                <span class="" >To Domain</span>
                <select-list
                  ref="domain"
                  title="Select Domain"
                  :withReset="true"
                  v-model="selectedDomain"
                  v-if="!sendToAll"
                >
                  <select-option
                    value="Domain 1"
                    name="Domain 1"
                  >
                    Domain 1
                  </select-option>
                  <select-option
                    value="Domain 2"
                    name="Domain 2"
                  >
                    Domain 2
                  </select-option>
                </select-list>
                <span v-else>No data</span>
              </div>
            </div>
          </div>

          <div class="message__form">
            <div
              class="form-userlist"
              v-if="users.length > 0"
            >
              <tbl>
                <tbl-inner>
                  <tbl-head>
                    <tbl-row>
                      <tbl-td name="checkbox">
                        <checkbox>
                          <input
                            type="checkbox"
                            @click="selectAll = !selectAll,
                              checkAll(users)"
                          />
                        </checkbox>
                      </tbl-td>

                      <tbl-td name="login-in">
                        Login ID
                      </tbl-td>

                      <tbl-td name="login-name">
                        Login Name
                      </tbl-td>

                      <tbl-td name="agent">
                        Agent
                      </tbl-td>

                      <tbl-td name="code">
                        Code
                      </tbl-td>
                      <tbl-td name="level">
                        Level
                      </tbl-td>
                    </tbl-row>
                  </tbl-head>

                  <tbl-body>
                    <tbl-row
                      v-for="(user, i) in users"
                      :key="i"
                    >
                      <tbl-td name="checkbox">
                        <checkbox>
                          <input
                          type="checkbox"
                          :value="user.id"
                          v-model="messageParam.user_id"
                          checked
                          />
                        </checkbox>
                      </tbl-td>

                      <tbl-td name="login-in">
                        {{ user.login_id }}
                      </tbl-td>

                      <tbl-td name="login-name">
                        {{ user.login_name }}
                      </tbl-td>

                      <tbl-td name="agent">
                        {{ user.code.agent_name }}
                      </tbl-td>

                      <tbl-td name="code">
                        {{ user.code.code }}
                      </tbl-td>
                      <tbl-td name="level">
                        {{ user.level.name }}
                      </tbl-td>
                    </tbl-row>
                  </tbl-body>
                </tbl-inner>
              </tbl>
            </div>

            <div class="form-wrap">
              <form class="form-con" action="" method="post">
                <div class="form-item">
                  <div class="textarea-wrap">
                    <quill-editor
                      ref="title"
                      :options="quillTitleConfig"
                      v-model="messageParam.title"
                    >
                    </quill-editor>
                  </div>
                </div>
                <div class="form-item">
                  <div class="textarea-wrap">
                    <quill-editor
                      ref="content"
                      :options="quillContentConfig"
                      v-model="messageParam.content"
                    >
                    </quill-editor>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="sendMessage()"
        >
          <i class="ico--message"></i>
          <span>Send</span>
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import Checkbox from '@/components/base/Checkbox'
import Modal from '@/components/base/Modal'
import TextArea from '@/components/base/TextArea'
import { quillEditor } from 'vue-quill-editor'

import { swal } from '@/assets/js/mixins/base/Swal'

import '@/components/base/select/Select'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  components: {
    Checkbox,
    Modal,
    TextArea,
    'quill-editor': quillEditor
  },

  mixins: [ swal ],

  props: {
    selectedUsers: {
      type: Array,
      default: () => {
        return []
      }
    },
    showMessageUser: Boolean
  },

  data () {
    return {
      messageParam: {
        user_id: [],
        title: null,
        content: null
      },
      selectedLevel: null,
      selectedAgent: null,
      selectedCode: null,
      selectedAccount: null,
      selectedDomain: null,
      sendToAll: false,
      selectAll: false,
      showModal: false,

      quillTitleConfig: {
        placeholder: 'Subject here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      },

      quillContentConfig: {
        placeholder: 'Content here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      }
    }
  },

  computed: {
    ...mapState('level', [ 'levels' ]),
    ...mapState('code', { allCodes: 'codes' }),
    ...mapState('agent', { allAgents: 'agents' }),
    ...mapState('deposit-account', [ 'depositAccounts' ]),

    users () {
      return this.selectedUsers
    },

    agents () {
      if (this.selectedAgent) {
        let agentId = this.allAgents.find((row) => {
          return this.selectedAgent === row.id
        })

        this.messageParam.user_id = this.selectedUsers.map((row) => {
          return agentId.login_id === row.code.agent_id ? row.id : ''
        })
      }

      if (!this.selectedCode) {
        return this.allAgents
      }

      let agentCode = this.allCodes.filter((row) => {
        return row.id === this.selectedCode
      })

      let result = this.allAgents.filter((row) => {
        return row.id === agentCode.map(foo => foo.agent_id)[0]
      })

      return result
    },

    accounts () {
      if (!this.selectedCode) {
        return this.depositAccounts
      }

      let depositCode = this.allCodes.filter((row) => {
        return row.id === this.selectedCode
      })

      let result = this.depositAccounts.filter((row) => {
        return row.id === depositCode.map(foo => foo.deposit_id)[0]
      })

      return result
    },

    codes () {
      let agentCodes
      let accountCodes
      let result = this.allCodes

      if (this.selectedAgent && this.selectedAccount) {
        agentCodes = this.allAgents.filter((row) => {
          return row.id === this.selectedAgent
        })

        accountCodes = this.depositAccounts.filter((row) => {
          return row.id === this.selectedAccount
        })

        result = this.allCodes.filter((row) => {
          return row.agent_id === agentCodes.map(foo => foo.id)[0]
        })

        result = result.filter((row) => {
          return row.deposit_id === accountCodes.map(foo => foo.id)[0]
        })
      }

      if (this.selectedAgent && !this.selectedAccount) {
        agentCodes = this.allAgents.filter((row) => {
          return row.id === this.selectedAgent
        })

        result = this.allCodes.filter((row) => {
          return row.agent_id === agentCodes.map(foo => foo.id)[0]
        })
      }

      if (this.selectedAccount && !this.selectedAgent) {
        accountCodes = this.depositAccounts.filter((row) => {
          return row.id === this.selectedAccount
        })

        result = this.allCodes.filter((row) => {
          return row.deposit_id === accountCodes.map(foo => foo.id)[0]
        })
      }

      return result
    }
  },

  watch: {
    selectedUsers (val) {
      this.messageParam.user_id = val.map((row) => {
        return row.id
      })
    },

    selectedLevel (val) {
      this.messageParam.user_id = this.selectedUsers.map((row) => {
        return val === row.level_id ? row.id : ''
      })

      if (!this.selectedAgent && !this.selectedCode &&
          !this.selectedAccount && !val) {
        this.messageParam.user_id = this.selectedUsers.map((row) => {
          return row.id
        })
      }
    },

    selectedAgent (val) {
      if (!this.selectedLevel && !this.selectedCode &&
          !this.selectedAccount && !val) {
        this.messageParam.user_id = this.selectedUsers.map((row) => {
          return row.id
        })
      }
    },

    selectedCode (val) {
      if (!this.selectedLevel && !this.selectedAgent &&
          !this.selectedCode && !val) {
        this.messageParam.user_id = this.selectedUsers.map((row) => {
          return row.id
        })
      }
    },

    selectedAccount (val) {
      if (!this.selectedLevel && !this.selectedAgent &&
          !this.selectedCode && !val) {
        this.messageParam.user_id = this.selectedUsers.map((row) => {
          return row.id
        })
      }
    },

    sendToAll (val) {
      if (val) {
        this.resetParams()
      }
    },

    showMessageUser (val) {
      this.showModal = val
    },

    showModal (val) {
      if (!val) {
        this.sendToAll = false
        this.messageParam.title = null
        this.messageParam.content = null
        this.resetParams()
        this.$emit('closeComponent', false)
      }
    }
  },

  methods: {
    ...mapActions('support', { createMessage: 'create' }),

    async sendMessage () {
      let success = async () => {
        let result = await this.createMessage(params)

        if (result.status === 201) {
          this.$alert('success', 'You have successfully created the message', {}, '', 'Success')
          this.sendToAll = false
          this.messageParam.title = null
          this.messageParam.content = null
          this.resetParams()
          this.showModal = false
          this.$emit('closeComponent', false)
        } else {
          this.$alert('error', 'No users found', {}, '', 'Message Error')
        }
      }

      let params = {
        title: this.messageParam.title,
        content: this.messageParam.content
      }

      let agentCode
      let accountCode
      let codes = []

      this.messageParam.user_id = this.messageParam.user_id.filter((row) => { return row !== '' })

      if (!this.messageParam.title || !this.messageParam.content) {
        this.$alert('error', 'Subject & Content are required', {}, '', 'Error')
        return
      }

      if (this.messageParam.title.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this.messageParam.content.replace(/(<([^>]+)>)/ig, ' ').trim() === '') {
        this.$alert('error', 'Subject & Content are required', {}, '', 'Error')
        return
      }

      // not null agent & group
      if (this.selectedAgent && this.selectedAccount) {
        codes = this.allCodes.map((row) => {
          return (row.agent_id === this.selectedAgent &&
            row.deposit_id === this.selectedAccount) ? row.id : null
        }).filter((e) => { return e })
      }

      if (this.selectedAgent && !this.selectedAccount) {
        agentCode = this.allCodes.map((row) => {
          return row.agent_id === this.selectedAgent ? row.id : null
        }).filter((e) => { return e })
        codes.push(agentCode)
      }

      if (this.selectedAccount && !this.selectedAgent) {
        accountCode = this.allCodes.map((row) => {
          return row.deposit_id === this.selectedAccount ? row.id : null
        }).filter((e) => { return e })
        codes.push(accountCode)
      }

      if (this.selectedCode) {
        codes = [ this.selectedCode ]
      }

      // flatten & remove duplicate values
      codes = codes.flat().reduce((acc, val) => acc.concat(val), [])
        .filter((val, index, arr) => arr.indexOf(val) === index)
        .filter((row) => { return row !== null })

      if (this.sendToAll) {
        params.sendToAll = true
      }

      if (codes.length > 0 && !this.sendToAll) {
        params.code_id = codes
      }

      if (this.selectedLevel && !this.sendToAll) {
        params.level_id = [ this.selectedLevel ]
      }

      if (this.messageParam.user_id.length > 0 && !this.sendToAll) {
        params = []
        for (let i = 0; i < this.messageParam.user_id.length; i++) {
          params.push({
            user_id: this.messageParam.user_id[i],
            title: this.messageParam.title,
            content: this.messageParam.content
          })
        }
      }

      if (this.selectedUsers.length > 0 &&
          !this.messageParam.user_id.length &&
          !this.sendToAll) {
        this.$alert('error', 'Choose User', {}, '', 'Error')
        return
      }

      if (!this.selectedUsers.length &&
          !this.sendToAll && !codes.length &&
          !this.selectedLevel) {
        this.$alert('error', 'Choose Recipient', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Create Message')
    },

    checkAll (data) {
      if (!this.selectAll) {
        this.messageParam.user_id = []
        return
      }

      this.messageParam.user_id = data.map((row) => {
        return row.id
      })
    },

    resetParams () {
      this.messageParam.user_id = []
      this.selectedLevel = null
      this.selectedAgent = null
      this.selectedCode = null
      this.selectedAccount = null
      this.selectedDomain = null
      this.$refs.level.reset = true
      this.$refs.agent.reset = true
      this.$refs.code.reset = true
      this.$refs.account.reset = true
      this.$refs.domain.reset = true
    }
  }
}
</script>
